import { render, staticRenderFns } from "./SmsSetting.vue?vue&type=template&id=63a30c5c&scoped=true"
import script from "./SmsSetting.vue?vue&type=script&lang=js"
export * from "./SmsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a30c5c",
  null
  
)

export default component.exports